import { IWithForms, IAppState } from '../types';

export const controlSelector = (formName: string, controlName: string) => (state: IWithForms) =>
    state.forms[formName]?.controlsState[controlName];

export const fieldSetSelector = (formName: string, fieldSetName: string) => (state: IWithForms) =>
    state.forms[formName]?.fieldSetState[fieldSetName];

export const formKeySelector = <K extends keyof IAppState>(formName: string, key: K) => (
    state: IWithForms,
): IAppState[K] | undefined =>
    (formName && state.forms[formName] && state.forms[formName][key]) || undefined;
